import { useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export default function useMarketBids() {
  const [bids, setBids] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const fetchBids = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/market/bids/`, { params });
      setBids(res.data);
    } catch (e) { /* no profile */ }
    finally { setLoading(false); }
  }, []);

  const createBid = useCallback(async (data) => {
    setSaving(true);
    try {
      const res = await axios.post(`${API}/market/bids/`, data);
      setBids(prev => [res.data, ...prev]);
      return res.data;
    } finally { setSaving(false); }
  }, []);

  const respondBid = useCallback(async (id, action) => {
    const res = await axios.post(`${API}/market/bids/${id}/respond/`, { action });
    setBids(prev => prev.map(b => b.id === id ? res.data : b));
    return res.data;
  }, []);

  return { bids, loading, saving, fetchBids, createBid, respondBid };
}
